import React from "react"
import Modal from "react-responsive-modal";
import { BLUE_LIT, GRAY_LIT } from "../../../../../utils/colors";

export function ModalAssessmentMediaList({ visible, onClose, listData = [] }) {
  return (
    <Modal
        open={visible}
        onClose={onClose}
        center
        classNames={{ modal: "modal-medium-lit" }}
        closeOnOverlayClick={false}

        // responde --> RESPONSE_12_EXAM_670FF2F6C2C793001359FA28_1
      >
        <div className="modal-content" style={{ border: 0 }}>
                <div className="modal-body">

                  <div style={{ width: '100%' }}>
                    <h3>Atividades enviadas</h3>
                    <p>Faça o download para conferir o envio das suas atividades</p>

                    {listData && (listData || []).map(item => (
                      <a style={{ 
                          padding: '10px 25px 20px 20px', 
                          background: '#F9F9F9', 
                          border: '1px solid #DDDDDD', 
                          marginBottom: 10,
                          flexDirection: 'row',
                          justifyContent: 'space-between',
                          cursor: 'pointer',
                          borderRadius: 5,
                          display: 'flex',
                          alignItems: 'center'
                        }}
                        href={item.url}
                        download>
                          <div style={{}}>
                            <span style={{ color: '#595959', fontSize: 10 }}>
                              {new Date(item.date_sent).toLocaleDateString('pt-br')} • {`${new Date(item.date_sent).getHours()}h${new Date(item.date_sent).getMinutes()}`}
                            </span><br />
                            <i style={{ fontSize: 22, color: BLUE_LIT }} className="fa fa-check" /> <span style={{ color: BLUE_LIT }}>{item.name}</span>
                          </div>
                          <div style={{ display: 'flex' }}>
                            <i style={{ fontSize: 20, color: GRAY_LIT }} className="fa fa-download" />
                          </div>
                      </a>
                    ))}
                  </div>
                  
                </div>
            </div>
      </Modal>
  )
}
